module.exports = __webpack_public_path__ + "static/media/ghost.d292db26.glb";